import React from 'react';
import HeaderConnectionDetail from '../Headers/HeaderConnectionDetail';

/**
 * HeaderConnectionDetailShowcase - Demonstrates the HeaderConnectionDetail component
 */
const HeaderConnectionDetailShowcase = () => {
  const handleBackClick = () => {
    alert('Back button clicked!');
  };

  const handleChatClick = () => {
    alert('Chat button clicked!');
  };

  const showcaseStyle = {
    marginBottom: '20px'
  };

  // Example variants
  const headerExamples = [
    {
      title: 'Basic Header with Name',
      props: {
        name: 'Max Fish',
        imageUrl: '',
        initialLetter: 'M',
        onBackClick: handleBackClick,
        onChatClick: handleChatClick,
        showPlaceholder: true
      }
    },
    {
      title: 'Header with Profile Image',
      props: {
        name: 'Jane Doe',
        imageUrl: 'https://i.pravatar.cc/150?img=5',
        initialLetter: 'J',
        onBackClick: handleBackClick,
        onChatClick: handleChatClick,
        showPlaceholder: false
      }
    },
    {
      title: 'Header with Long Name',
      props: {
        name: 'Christopher Alexander Bartholomew Williamson III',
        imageUrl: '',
        initialLetter: 'C',
        onBackClick: handleBackClick,
        onChatClick: handleChatClick,
        showPlaceholder: true
      }
    },
    {
      title: 'Header without Chat Button',
      props: {
        name: 'James Wilson',
        imageUrl: '',
        initialLetter: 'J',
        onBackClick: handleBackClick,
        onChatClick: null,
        showPlaceholder: true
      }
    }
  ];

  return (
    <div>
      {headerExamples.map((example, index) => (
        <div key={index} style={showcaseStyle}>
          <h3>{`${index + 1}. ${example.title}`}</h3>
          <HeaderConnectionDetail {...example.props} />
        </div>
      ))}
    </div>
  );
};

export default HeaderConnectionDetailShowcase;
